export default __webpack_public_path__ + "static/media/carecentreicon.47385376.gif";